/*
 * @Descripttion:
 * @version:
 * @Author: tangshuo
 * @Date: 2022-09-21 14:57:51
 * @LastEditors: tangshuo
 * @LastEditTime: 2022-09-21 15:28:32
 */
import React from 'react';
import { Alert, Icon } from '@firesoon/antd';
import { props } from './interface';
import './index.less';

export default ({ isLink, message, onLink, ...ret }: props) => {
  const mes = () => {
    if (isLink) {
      return (
        <div className="fs-alert-message">
          {message}
          <span className="fs-alert-link" onClick={onLink}>
            详情
            <Icon type="right" />
          </span>
        </div>
      );
    }
    return message;
  };

  return (
    <div className="fs-alert">
      <Alert message={mes()} {...ret} />
    </div>
  );
};
